import { Instance } from 'mobx-state-tree';
import { ProjectStopUnscheduledDtoModelBase } from './ProjectStopUnscheduledDtoModel.base';

/* The TypeScript type of an instance of ProjectStopUnscheduledDtoModel */
export interface ProjectStopUnscheduledDtoModelType extends Instance<typeof ProjectStopUnscheduledDtoModel.Type> {}

/* A graphql query fragment builders for ProjectStopUnscheduledDtoModel */
export { selectFromProjectStopUnscheduledDto, projectStopUnscheduledDtoModelPrimitives, ProjectStopUnscheduledDtoModelSelector } from './ProjectStopUnscheduledDtoModel.base';

/**
 * ProjectStopUnscheduledDtoModel
 *
 * Stop unscheduled
 */
export const ProjectStopUnscheduledDtoModel = ProjectStopUnscheduledDtoModelBase
  .actions(self => ({
    // This is an auto-generated example action.
    log() {
      console.log(JSON.stringify(self));
    },
  }));
